export default "__VITE_ASSET__CLp7e$cf__"